<template>
  <ul class="cat-list">
    <li v-for="(data, key) in categories">
      <router-link :to="{ name: 'CategoryItems', params: { gender: 'all', category: key} }">{{data.name}}</router-link>
    </li>
  </ul>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import config from '../mixins/config'

export default {
  name: 'about',
  components: {
    Loading
  },
  mixins: [ config ],
  data () {
    return {
      List: [],
    }
  },
  mounted: function(){
    let title = 'カテゴリー一覧'
    let description = 'sports styleのアイテムカテゴリー一覧ページ。カテゴリ一覧から、アイテムを探すことができます。'
    this.setHeader(title, description, true)
    this.$store.commit('chageHeadTitle', 'カテゴリー')
  }
}
</script>

<style scoped>
  .cat-list li{
    border-bottom: 1px solid #DDD;
    text-align: left;
  }

  .cat-list li a{
    text-decoration: none;
    color: #333;
    padding: 16px;
    display: block;
    position: relative;
  }

  .cat-list li a:after{
    font-family: "Font Awesome 5 Free";
    content: "\f054";
    font-weight: 900;
    position: absolute;
    right: 16px;
    color: #AAA;
  }
</style>
